import getEditToken from "../../getters/editToken";

const tsDiagramToken = getEditToken("ts-diagram");

export default tsDiagramToken;
